import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Modal } from "./Modal";

export type ErrorModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: React.ReactNode;
  icon?: IconProp;
  maxWidth?: "sm" | "md" | "lg" | "xl";
};

export const ErrorModal = ({
  isOpen,
  onClose,
  title = "Erreur",
  message,
  icon = "exclamation-circle",
  maxWidth = "sm",
}: ErrorModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      icon={icon}
      maxWidth={maxWidth}
    >
      <div className="text-center">
        <p className="text-red-600 mb-2">{message}</p>
      </div>
    </Modal>
  );
};
